




































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import UpdateLocationWorkerRequest from "@/models/LocationWorkers/UpdateLocationWorkerRequest";
import ListUtils from "@/lib/listUtils";
import LocationWorkerDto from "@/models/LocationWorkers/LocationWorkerDto";
@Component({
  name: "LocationWorkerEdit",
})
export default class extends GiganautVueDialog {

  public request = new UpdateLocationWorkerRequest();

  @Prop({ required: true })
  locationWorker: LocationWorkerDto;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateLocationWorkerRequest();
      this.request.type = this.locationWorker.type;
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  get types() {
    return ListUtils.locationWorkerTypes();
  }

  async save() {
    this.request.locationWorkerId = this.locationWorker.id;
    this.request.updatedAt = this.locationWorker.updatedAt;
    await LocationDetailsModule.updateLocationWorker(this.request);
    this.dialog = false;
  }
}
